export default __webpack_public_path__ + "fsk_poster.png";